/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Meja_NInputs */

const en_tut_meja_n = /** @type {(inputs: Tut_Meja_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only the current desk holder can set the desk kind or create its call, and you have to be standing next to the desk. Changing the kind ends a call in progress. Worth knowing: once you release the desk or it changes hands, recordings from that desk call are queued for deletion — download them first if you still need them.`)
};

const id_tut_meja_n = /** @type {(inputs: Tut_Meja_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanya pemilik meja saat itu yang bisa mengatur jenis meja atau membuat panggilannya, dan Anda harus berdiri di sebelah mejanya. Mengganti jenis meja mengakhiri panggilan yang sedang berjalan. Penting: begitu Anda melepas meja atau meja itu berpindah tangan, rekaman dari panggilan meja tersebut diajukan untuk dihapus — unduh dulu kalau masih dibutuhkan.`)
};

/**
* | output |
* | --- |
* | "Only the current desk holder can set the desk kind or create its call, and you have to be standing next to the desk. Changing the kind ends a call in progres..." |
*
* @param {Tut_Meja_NInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_meja_n = /** @type {((inputs?: Tut_Meja_NInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Meja_NInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_meja_n(inputs)
	return en_tut_meja_n(inputs)
});